// import React, { useState } from "react";
// import { FaMountain, FaHotel, FaUtensils } from "react-icons/fa";


// const Itinerary = ({ itinerary }) => {
//   const itineraryData = JSON.parse(itinerary);
//   const [activeIndex, setActiveIndex] = useState(null);

//   const toggleAccordion = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   return (
//     <div className="itinerary">
//       {itineraryData.map((item, index) => (
//         <div
//           key={index}
//           className={`day ${activeIndex === index ? "active" : ""}`}
//         >
//           <div className="day-header" onClick={() => toggleAccordion(index)}>
//              {item.title}
//           </div>
//           {activeIndex === index && (
//             <div className="day-details">
//               <p className="details">{item.details}</p>
//               <div className="additional-info">
//                 {item.altitude && (
//                   <div className="info-item">
//                           <FaMountain />
//                     <span className="info-label">Altitude:</span>
//                     <span className="info-value">
//                       {item.altitude}
//                     </span>
//                   </div>
//                 )}
//                 {item.accommodations && (
//                   <div className="info-item">
//                           <FaHotel />
//                     <span className="info-label">Accommodation:</span>
//                     <span className="info-value">
//                       {item.accommodations}
//                     </span>
//                   </div>
//                 )}
//                 {item.meals && (
//                   <div className="info-item">
//                           <FaUtensils />
//                     <span className="info-label">Meals:</span>
//                     <span className="info-value">
//                       {item.meals}
//                     </span>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default Itinerary;
import React, { useState } from "react";
import { FaMountain, FaHotel, FaUtensils, FaChevronDown, FaChevronUp } from "react-icons/fa";

const Itinerary = ({ itinerary }) => {
  const itineraryData = JSON.parse(itinerary);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="itinerary">
      {itineraryData.map((item, index) => (
        <div
          key={index}
          className={`day ${activeIndex === index ? "active" : ""}`}
        >
          <div className="day-header" onClick={() => toggleAccordion(index)}>
            <div className="day-number">
              <span>Day {index + 1}</span>
            </div>
            <div className="day-title">
              <h3>{item.title}</h3>
            </div>
            <div className="day-toggle">
              {activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}
            </div>
          </div>
          {activeIndex === index && (
            <div className="day-details">
              <div className="details-content">
                <p className="details">{item.details}</p>
                <div className="additional-info">
                  {item.altitude && (
                    <div className="info-item">
                      <div className="info-icon">
                        <FaMountain />
                      </div>
                      <div className="info-content">
                        <span className="info-label">Altitude:</span>
                        <span className="info-value">{item.altitude}</span>
                      </div>
                    </div>
                  )}
                  {item.accommodations && (
                    <div className="info-item">
                      <div className="info-icon">
                        <FaHotel />
                      </div>
                      <div className="info-content">
                        <span className="info-label">Accommodation:</span>
                        <span className="info-value">{item.accommodations}</span>
                      </div>
                    </div>
                  )}
                  {item.meals && (
                    <div className="info-item">
                      <div className="info-icon">
                        <FaUtensils />
                      </div>
                      <div className="info-content">
                        <span className="info-label">Meals:</span>
                        <span className="info-value">{item.meals}</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="day-highlights">
                {item.highlights && (
                  <>
                    <h4>Highlights</h4>
                    <ul>
                      {item.highlights.map((highlight, idx) => (
                        <li key={idx}>{highlight}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Itinerary;